import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'cccisd-footer';
import Header from 'js/components/Header';
import style from './style.css';
import classnames from 'classnames';
import Banner from '../../components/Banner';

export default class GameFixedLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        showPrimaryNav: PropTypes.bool,
        showFooter: PropTypes.bool,
        bannerType: PropTypes.string,
    };

    static defaultProps = {
        className: 'container',
        showPrimaryNav: true,
        showFooter: true,
    };

    render() {
        return (
            <div className={classnames(style.wrapper, 'container-fluid')}>
                {this.props.showPrimaryNav && <Header className={this.props.className} />}

                {this.props.bannerType && <Banner bannerType={this.props.bannerType} />}

                <div className={classnames(style.body, 'container-fluid')}>
                    <div className="container">{this.props.children}</div>
                </div>

                <div className={style.footer}>
                    <Footer className="container" />
                </div>
            </div>
        );
    }
}
